exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".butter-toast-tray .action-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: transform .4s, opacity .3s; }\n  .butter-toast-tray .action-wrapper.shown {\n    opacity: 1; }\n  .butter-toast-tray .action-wrapper.clickable {\n    cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ActionWrapper/style.scss
// module id = 118
// module chunks = 0